/*
  Project: ewg
  Author: schittweiter GmbH
 */

import './modules/appHeight';
import './modules/trigger';
import './modules/clipboard';
import './modules/menu';
import './modules/sticky';
import './modules/parallax';
import './modules/lazy';
import './modules/intro';
import './modules/text';
import './modules/tabs';
import './modules/count';
import './modules/contactPerson';
import './modules/videoPlayer';
import './modules/storySlider';
import './modules/videoSlider';
import './modules/imageSlider';
import './modules/masonry';
import './modules/factGrid';
import './modules/smoothScroll';
import './modules/videoLightbox';
import './modules/accordion';
import './modules/downloads';
import './modules/scrollyTelling';
import './modules/storyParallax';
import './modules/collapse';
import './modules/mobileSharer';
import './modules/loadMoreCards';
import loadMore from './modules/loadmore';
import facet from './modules/facet';
import inView from './modules/inView';
import './modules/network';
import './modules/responsiveText';
import './modules/hyphen';

facet.init();

window.addEventListener(
  'DOMContentLoaded',
  async () => {
    const alertEl = document.querySelector('.c-alert');

    if (alertEl) {
      const headerEl = document.querySelector('.c-header');
      await headerEl.style.setProperty(
        '--alertHeight',
        `${alertEl.getBoundingClientRect().height}px`,
      );
    }

    setTimeout(() => {
      document.body.classList.add('content-loaded');
    }, 1000);

    // Add Load More Button to Social Media Wall
    loadMore('[data-load-more="social"]', '.c-grid__main--social');

    // Add inView Animation utility
    inView('.u-inview');
  },
  { once: true },
);



// WEBPACK FOOTER //
// ./src/scripts/app.js